<template>
  <section>
    <b-alert show v-if="!viewOnly">Please note that the margin report only counts outgoing orders, and not charges for returns, receipts and so on.</b-alert>
    <b-row>
      <b-form-group class="col-12" label="Client:">
        <b-v-select
          :disabled="viewOnly"
          v-model="reportFilters.brandId"
          :searchable="true"
          :options="brandsFilter"
        />
      </b-form-group>
      <b-form-group class="col-12" label="Warehouse:">
        <b-v-select
        :disabled="viewOnly"
          v-model="reportFilters.warehouseId"
          :searchable="true"
          :options="warehousesListAll"
        />
      </b-form-group>
      <b-form-group class="col-sm-6" label="Date Filters:" description="From Date must be before To Date">
        <b-form-select :disabled="viewOnly" v-model="reportFilters.dateFilter" :options="projectDateOpts" />
      </b-form-group>
      <template v-if="reportFilters.dateFilter == 'custom'">
        <b-form-group class="col-sm-6"  label="From Shipped Date:" description="From Date must be before To Date">
          <Flatpickr :disabled="viewOnly" v-model="reportFilters.startDate" :config="flatpickrConfig" class="form-control flatpickr-input"
            placeholder="Select date" name="startDate" />
        </b-form-group>

        <b-form-group class="col-sm-6" label="To Date (excluded!):">
          <Flatpickr :disabled="viewOnly" v-model="reportFilters.endDate" :config="flatpickrConfig" class="form-control flatpickr-input"
            placeholder="Select date" name="endDate" />
        </b-form-group>
        <div class="col-sm-12 alert alert-warning">
          <b>Explanation</b>: Setting the dates as 01/01/2000 -
          01/07/2000, will check all orders shipped <b>on or after</b> the
          1st and <b>before</b> the 7th of January.
        </div>
      </template>
    </b-row>
  </section>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  components: {
  },
  name: 'OrderedStorefrontItemsReport-form',
  props: {
    reportFilters: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customersList: {
      get() {
        let itmsList = [];
        let myItems = this.$store.getters.getMyTPL.customers;
        myItems.forEach(itm => {
          itmsList.push({ value: itm.id, text: itm.companyName  +  ' (ID: ' + itm.id+ ')' });
        });
        return itmsList;
      },
      set(val) {
        //this.$store.commit('setCustomersList', val);
      }
    },
    facilityList: {
      get() {
        let itmsList = [];
        let myItems = this.$store.getters.getMyTPL.facilities;
        myItems.forEach(itm => {
          itmsList.push({ value: itm.id, text: itm.name  +  ' (ID: ' + itm.id+ ')' });
        });
        return itmsList;
      },
      set(val) {
        //this.$store.commit('setCustomersList', val);
      }
    },
  },
  watch: {
    'storefrontIdsPicked': function(val) {
      let arr = [];
      if(val.length>0) {
        val.forEach((it) => {
          arr.push(it.value);
        })
      }
      this.reportFilters.storefrontIds = arr;
    }
  },
  data() {
    return {
      storefrontIdsPicked: [],
      projectDateOpts: [
        // { value: '', text: "All" },
        { value: 'this-week', text: 'This Week' },
        { value: 'last-week', text: 'Last Week' },
        { value: 'this-month', text: 'This Month' },
        { value: 'last-month', text: 'Last Month' },
        { value: 'custom', text: 'Custom Date Range' }
      ],
      flatpickrConfig: {
        altFormat: 'j F Y',
        altInput: true,
        dateFormat: 'Y-m-d'
      }
    }
  },
  mounted() {
    this.$store.dispatch('fetchMyTPLData');
  }
}
</script>

<style>

</style>
